import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { OpportunityStatus, WorkForecast } from '@catalyst-psa/shared';

import { api } from '../../api/client.js';
import { buildQuery } from '../../api/queryString.js';

/** Filters accepted by the upcoming-work forecast endpoint. */
export interface WorkForecastParams {
  customerId?: string;
  salesRepId?: string;
  serviceCategoryId?: string;
  status?: OpportunityStatus;
}

const workForecastKeys = {
  all: ['work-forecast'] as const,
};

export function useWorkForecast(
  params: WorkForecastParams = {},
  enabled = true,
): UseQueryResult<WorkForecast> {
  return useQuery({
    queryKey: [...workForecastKeys.all, params] as const,
    queryFn: () =>
      api.get<WorkForecast>(
        `/opportunities/work-forecast${buildQuery({
          customerId: params.customerId,
          salesRepId: params.salesRepId,
          serviceCategoryId: params.serviceCategoryId,
          status: params.status,
        })}`,
      ),
    staleTime: 60_000,
    enabled,
  });
}
